import React from 'react';
import moment from 'moment-timezone';
import renderHTML from 'react-render-html';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactToPrint from "react-to-print";
import Select from 'react-select';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { patronActionCreators } from '../../../stores/lis-patron-store';
import { voteActionCreators } from '../../../stores/lis-votes-store';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { orgActionCreators } from '../../../stores/lis-org-store';
import { cancelRequest } from '../../../services/request.service';
import '../../../stylesheets/lis-public-view/public-view.css';
import LoaderComponent from '../../../lis-shared/lis-layout/components/lis-loader-component';
import ImpactStatementForm from './lis-impact-statements';
import Collections from './lis-collections';
import queryString from 'query-string';
import { minutesActionCreators } from '../../../stores/lis-minutes-store';
import { memberActionCreators } from '../../../stores/lis-members-store';
import { Editor } from '@tinymce/tinymce-react';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import BillHistoryForm from './lis-history-form';
import ReportMaker from '../lis-bill-search/lis-report-maker';

const BILL_EVENT_VIEWER = "LegislationEvent";
const BILL_EVENT_AUTHOR = "LegislationEventHistory";
const BILL_COLLECTION_AUTHOR = "LegislationCollections";
const BILL_AUTHOR = "Legislation";
const VERSION_AUTHOR = "LegislationText";
const PATRON_AUTHOR = "LegislationPatron";

const TEXT_EVENTS = ["H5030", "H5030", "H5031", "H5032", "H5033", "H5034", "H5035", "H5036", "S5030", "S5031", "S5032", "S5033", "S5034", "S5035", "S5036", "S5037", "C6038", "C6038", "H4230", "H4230", "H4278", "H4278", "S4230", "S4230", "S4278", "S4278", "H4232", "H4232", "H4280", "H4280", "S4232", "S4232", "S4280", "S4280", "S4218", "S4218", "H0141", "H0141", "H0241", "H0241", "H2341", "H2341", "H2141", "H2141", "H0741", "H0741", "H0841", "H0841", "H0941", "H0941", "H1041", "H1041", "H1141", "H1141", "H2441", "H2441", "H1441", "H1441", "H1841", "H1841", "H1541", "H1541", "H2041", "H2041", "H1941", "H1941", "H0142", "H0142", "H0242", "H0242", "H2342", "H2342", "H2142", "H2142", "H0742", "H0742", "H0842", "H0842", "H0942", "H0942", "H1042", "H1042", "H1142", "H1142", "H2442", "H2442", "H1442", "H1442", "H1842", "H1842", "H1542", "H1542", "H2042", "H2042", "H1942", "H1942", "H0106", "H0106", "H0107", "H0107", "H0108", "H0108", "H0109", "H0109", "S0106", "S0106", "S0107", "S0107", "S0108", "S0108", "S0109", "S0109", "S0110", "S0110", "H0206", "H0206", "H0207", "H0207", "H0208", "H0208", "H0209", "H0209", "H0307", "H0307", "H0407", "H0407", "H2306", "H2306", "H2307", "H2307", "H2308", "H2308", "H2309", "H2309", "S0206", "S0206", "S0207", "S0207", "S0208", "S0208", "S0209", "S0209", "S0210", "S0210", "H2106", "H2106", "H2107", "H2107", "H2108", "H2108", "H2109", "H2109", "H0507", "H0507", "H0607", "H0607", "H0706", "H0706", "H0707", "H0707", "H0708", "H0708", "H0709", "H0709", "H0806", "H0806", "S1306", "S1306", "H0807", "H0807", "S1307", "S1307", "H0808", "H0808", "S1308", "S1308", "S1309", "S1309", "H0809", "H0809", "S1310", "S1310", "S0406", "S0406", "S0407", "S0407", "S0408", "S0408", "S0409", "S0409", "S0410", "S0410", "H0906", "H0906", "H0907", "H0907", "H0908", "H0908", "H0909", "H0909", "S0506", "S0506", "S0507", "S0507", "S0508", "S0508", "S0509", "S0509", "S0510", "S0510", "H1006", "H1006", "H1007", "H1007", "H1008", "H1008", "H1009", "H1009", "S1206", "S1206", "S1207", "S1207", "S1208", "S1208", "S1209", "S1209", "S1210", "S1210", "H1106", "H1106", "H1107", "H1107", "S0607", "S0607", "H1108", "H1108", "H1109", "H1109", "H2406", "H2406", "H2407", "H2407", "H2408", "H2408", "H2409", "H2409", "H1307", "H1307", "H1406", "H1406", "H1407", "H1407", "H1408", "H1408", "H1409", "H1409", "S0706", "S0706", "S0707", "S0707", "S0708", "S0708", "S0709", "S0709", "S0710", "S0710", "H1707", "H1806", "H1806", "S0806", "S0806", "H1807", "H1807", "S0807", "S0807", "H1808", "H1808", "S0808", "S0808", "S0809", "S0809", "H1809", "H1809", "S0810", "S0810", "H4002", "S4002", "H4210", "H4210", "S4210", "S4210", "H4212", "H4212", "S4212", "S4212", "H4410", "H4410", "S4410", "S4410", "H4640", "H4640", "S4640", "S4640", "H4642", "S4642", "H1506", "H1506", "S4642", "H1507", "H1507", "S4211", "S4211", "H4211", "H4211", "H4641", "H4641", "S4641", "S4641", "H4643", "S4643", "S5430", "C6045", "C6045", "S5431", "H8122", "H8122", "H5500", "H5510", "H5520", "H5530", "H5700", "H5710", "H5720", "H5730", "H5740", "H8120", "H8120", "C6049", "C6049", "S5432", "S5433", "C6050", "C6050", "S5434", "H1508", "H1508", "H1509", "H1509", "S0906", "S0906", "S0907", "S0907", "S0908", "S0908", "S0909", "S0909", "S0910", "S0910", "H2006", "H2006", "S1006", "S1006", "H2007", "H2007", "S1007", "S1007", "H2008", "H2008", "S1008", "S1008", "S1009", "S1009", "H2009", "H2009", "S1010", "S1010", "H1906", "H1906", "S1106", "S1106", "H1907", "H1907", "S1107", "S1107", "H1908", "H1908", "S1108", "S1108", "S1109", "S1109", "H1909", "H1909", "S1110", "S1110", "H0117", "H0117", "H0217", "H0217", "H0717", "H0717", "H0817", "H0817", "H0917", "H0917", "H1017", "H1017", "H1117", "H1117", "H1417", "H1417", "H1517", "H1517", "H1817", "H1817", "H1917", "H1917", "H2017", "H2017", "H2117", "H2117", "H2317", "H2317", "H2417", "H2417", "S0117", "S0117", "S0217", "S0217", "S0417", "S0417", "S0517", "S0517", "S0717", "S0717", "S0817", "S0817", "S0917", "S0917", "S1017", "S1017", "S1117", "S1117", "S1217", "S1217", "S1317", "S1317", "H0118", "H0118", "H0218", "H0218", "H0718", "H0718", "H0818", "H0818", "H0918", "H0918", "H1018", "H1018", "H1118", "H1118", "H1418", "H1418", "H1518", "H1518", "H1818", "H1818", "H1918", "H1918", "H2018", "H2018", "H2118", "H2118", "H2318", "H2318", "H2418", "H2418", "S0118", "S0118", "S0218", "S0218", "S0418", "S0418", "S0518", "S0518", "S0718", "S0718", "S0818", "S0818", "S0918", "S0918", "S1018", "S1018", "S1118", "S1118", "S1218", "S1218", "S1318", "S1318", "H0119", "H0119", "H0219", "H0219", "H0719", "H0719", "H0819", "H0819", "H0919", "H0919", "H1019", "H1019", "H1119", "H1119", "H1419", "H1419", "H1519", "H1519", "H1819", "H1819", "H1919", "H1919", "H2019", "H2019", "H2119", "H2119", "H2319", "H2319", "H2419", "H2419", "S0119", "S0119", "S0219", "S0219", "S0419", "S0419", "S0519", "S0519", "S0719", "S0719", "S0819", "S0819", "S0919", "S0919", "S1019", "S1019", "S1119", "S1119", "S1219", "S1219", "S1319", "S1319", "H5020", "H5021", "H5022", "H5023", "H5024", "S5020", "S5021", "S5022", "S5023", "S5024", "H5430", "C6047", "C6047", "H5431", "S8122", "S8122", "S5500", "S5510", "S5520", "S5530", "S5535", "S5700", "S5710", "S5720", "S5730", "S5740", "S8120", "S8120", "C6052", "C6052", "H5432", "H5433", "C6053", "C6053", "H5434", "H4645", "H4645", "S4645", "H4420", "H4420", "H4648", "H4450", "S4420", "S4420", "S4450", "S4450", "H4173", "H4173", "S4173", "S4173", "C6020", "C6020", "H8123", "S8123", "S4620", "H4620", "H4602", "S4602", "H7000", "S7000", "H4601", "S4601", "H7010", "S7010"];
const CONFERENCE_EVENTS = [""]; //story 21455 has tasks with codes
const GOV_EVENTS = ["G7210", "H7211", "S7211", "H7946", "S7946", "H7950", "S7950", "G7320", "G7220", "G7321", "G7322", "G7324", "H7300", "S7300", "H7308", "S7308", "H7321", "S7321"];

const PARENT_ELIGIBLE_EVENTS = ["amend", "conference report", "governor's recommendation", "veto"];

const ACCESS_ROLES = ["Admin", "HouseHistoryEditor", "SenateHistoryEditor"];

const SUMMARY = "summary";
const DESCRIPTION = "description";

const isStatic = window.location.pathname.includes('static');

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px'
    }),
    multiValue: styles => ({
        ...styles,
        maxWidth: "300px"
    })
}

function PatronName(props) {
    return (
        <Link to={`/session-details/${props.session.SessionCode}/member-information/${props.MemberNumber}/member-details`}>{props.MemberDisplayName}{props.ByRequest && props.DisplayName ? ' ' + props.DisplayName.replace(')', ', By Request)') : props.DisplayName ? ' ' + props.DisplayName : props.ByRequest ? ' (By Request)' : null}</Link>
    );
}

function PatronList(props) {
    var patronsLength = props.patrons.length;
    const listPatrons = props.patrons.map((patrons, i) => {
        if (props.list) {
            return <li><PatronName session={props.session} key={i} {...patrons} /></li>
        } else if (patronsLength === i + 1) {
            return <PatronName session={props.session} key={i} {...patrons} />
        } else {
            return <span key={i}><PatronName session={props.session} {...patrons} />, </span>
        }
    });
    return props.list ? <ul className="list-two no-list-style">{listPatrons}</ul> : <span>{listPatrons}</span>;
}

class NewBillDetailsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            billData: '',
            billHistory: [],
            summariesList: [],
            housePatronsList: [],
            senatePatronsList: [],
            versionsList: [],
            chiefPatronsList: [],
            sessionData: '',
            toolTip: false,
            editingHistory: false,
            billEvents: [],
            organizedEvents: [],
            actionTypes: [],
            memberList: [],
            committeeList: [],
            editing: {},
            description: "",
            saving: false,
            displayStatementForm: false,
            statementSubmitting: false,
            statementLegislationTextID: '',
            statementDate: '',
            statementDescription: '',
            agencyOptions: [],
            statementDocumentcode: '',
            reconsiderationEvents: [],
            hideAllEvents: true,
            patronList: [],
            collections: [],
            collectionIsLoading: false,
            showPopup: false,
            watchlists: [],
            selectedWatchlists: [],
            showWatchlistForm: false,
            noteWatchlists: [],
            noteText: "",
            showNoteForm: false,
            showWatchlistList: false,
            collapsedEventReferences: [],
            collapseAll: false,
            showReportMaker: false,
            versionList: [],
            eventReferenceValue: {},
            showDeleteImpactStatementModal: false,
            defaultHistoryOrder: true,
            showVersions: false
        };
        this.setupPage = this.setupPage.bind(this);
        this.getBillDetails = this.getBillDetails.bind(this);
        this.getBillHistory = this.getBillHistory.bind(this);
        this.getPatrons = this.getPatrons.bind(this);
        this.saveDescription = this.saveDescription.bind(this);
        this.saveSummary = this.saveSummary.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleStatementForm = this.toggleStatementForm.bind(this);
        this.submitImpactStatement = this.submitImpactStatement.bind(this);
        this.closeStatementForm = this.closeStatementForm.bind(this);
        this.checkForDuplicates = this.checkForDuplicates.bind(this);
        this.togglePatronModal = this.togglePatronModal.bind(this);
        this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
        this.handleSaveWatchlistss = this.handleSaveWatchlistss.bind(this);
        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.handleSaveWatchlists = this.handleSaveWatchlists.bind(this);
        this.toggleWatchlistList = this.toggleWatchlistList.bind(this);
        this.getCollections = this.getCollections.bind(this);
        this.handleRemoveWatchlists = this.handleRemoveWatchlists.bind(this);
        this.handleNoteTextChange = this.handleNoteTextChange.bind(this);
        this.handleNoteWatchlistChange = this.handleNoteWatchlistChange.bind(this);
        this.toggleNotesForm = this.toggleNotesForm.bind(this);
        this.addCommitteeLink = this.addCommitteeLink.bind(this);
        this.toggleHistoryOrder = this.toggleHistoryOrder.bind(this);
        this.toggleEventReferenceCollapse = this.toggleEventReferenceCollapse.bind(this)
        this.toggleEventReferenceCollapseAll = this.toggleEventReferenceCollapseAll.bind(this)
        this.toggleEditContent = this.toggleEditContent.bind(this);
        this.handleEventChange = this.handleEventChange.bind(this);
        this.saveEvents = this.saveEvents.bind(this);
        this.togglehideAllEvents = this.togglehideAllEvents.bind(this);
        this.toggleReportMaker = this.toggleReportMaker.bind(this);
        this.getBillVersions = this.getBillVersions.bind(this);
        this.toggleEventReferenceEdit = this.toggleEventReferenceEdit.bind(this);
        this.saveEventReference = this.saveEventReference.bind(this);
        this.handleEventReferenceChange = this.handleEventReferenceChange.bind(this);
        this.toggleDisplayStatementForm = this.toggleDisplayStatementForm.bind(this);
        this.toggleDeleteImpactStatementModal = this.toggleDeleteImpactStatementModal.bind(this);
        this.toggleEventReferenceCreate = this.toggleEventReferenceCreate.bind(this);
        this.createEventReference = this.createEventReference.bind(this);
        this.toggleDeleteEventReferenceModal = this.toggleDeleteEventReferenceModal.bind(this);
        this.deleteEventReference = this.deleteEventReference.bind(this);
        this.toggleEventReferenceParent = this.toggleEventReferenceParent.bind(this);
        this.setEventReferenceParent = this.setEventReferenceParent.bind(this);
        this.getReconsiderationEvents = this.getReconsiderationEvents.bind(this);
        this.hasAccess = this.hasAccess.bind(this);
        this.toggleVersionList = this.toggleVersionList.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const sessionCode = this.props.params.sessionCode;
        let legislationNumber = this.props.params.billnumber;

        //if legislation number is zero-padded (such as from a calendar), remove the zero-padding
        const legislationNumberDigitsWithZeroPadding = legislationNumber.match(/\d+/); //e.g. 0259
        if (legislationNumberDigitsWithZeroPadding) {
            const legislationNumberDigitsWithOutZeroPadding = parseInt(legislationNumberDigitsWithZeroPadding[0]); //turns 0259 into 259
            legislationNumber = legislationNumber.replace(/\d+/, legislationNumberDigitsWithOutZeroPadding); //turns HB0259 into HB259
        }

        this.setupPage(sessionCode, legislationNumber);
    }

    componentDidUpdate(prevProps) {
        const sessionCode = this.props.params.sessionCode;
        const legislationNumber = this.props.params.billnumber;
        const previousSessionCode = prevProps.params.sessionCode;
        const previousLegislationNumber = prevProps.params.billnumber;
        if (previousSessionCode !== sessionCode || previousLegislationNumber !== legislationNumber) {
            this.setState({
                summaryIsLoaded: false,
                versionsIsLoaded: false,
                patronIsLoaded: false,
                billDataIsLoaded: false
            }, () => {
                this.setupPage(sessionCode, legislationNumber);
            })
        } else if (JSON.stringify(prevProps.login.userClaims.resources) !== JSON.stringify(this.props.login.userClaims.resources)) {
            if (!this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR)) {
                this.setState({ editing: {} })
            }
            this.setupPage(sessionCode, legislationNumber);
        }
    }

    componentWillUnmount() {
        cancelRequest();
    }

    setupPage(sessionCode, legislationNumber) {
        this.props.actions.getSessionByCode(sessionCode).then(() => {
            if (this.props.session.selectedSession) {
                this.setState({
                    sessionData: this.props.session.selectedSession,
                    conveneDate: this.props.session.selectedSession.SessionStart,
                    legislationNumber: legislationNumber
                }, () => {
                    this.getBillDetails(legislationNumber, sessionCode);
                    this.getBillSummary(legislationNumber, sessionCode);
                    this.getBillVersions(legislationNumber, sessionCode);

                    if (this.props.login.isAuthenticated) {
                        this.getCollections("?SessionID=" + this.state.sessionData.SessionID);
                    }
                });
                this.props.actions.getCommitteeList('sessionID=' + this.props.session.selectedSession.SessionID + "&includeSubCommittees=true").then(() => {
                    let committeeList = this.props.committee.committeeList;
                    committeeList.forEach(committee => {
                        committee.label = committee.Name;
                        committee.value = committee.CommitteeID;
                        committee.abbrev = committee.Abbreviation;
                    });
                    this.setState({
                        committeeList: committeeList
                    });
                });
            }
        }).catch(err => {
            if (err === "Aborted") {
                return;
            }
            this.setState({
                billDataIsLoaded: true,
                patronIsLoaded: true,
                billData: ''
            });
        });

        this.props.actions.getMemberList('sessionCode=' + sessionCode).then(() => {
            let memberList = [...this.props.members.memberList];
            memberList.forEach(member => {
                member.label = member.PatronDisplayName;
                member.value = member.MemberID;
            });
            this.setState({
                memberList: memberList
            });
        });
        this.props.actions.getActionTypes()
            .then(() => {
                let actionTypes = [...this.props.minutes.actionTypes];
                actionTypes.forEach(type => {
                    type.label = type.ActionReferenceType;
                    type.value = type.ActionReferenceTypeID;
                })
                this.setState({
                    actionTypes: actionTypes
                });
            });
        this.props.actions.getAgencyList().then(() => {
            let agencies = [...this.props.organizations.agencyList]
            agencies.forEach((agency, i) => {
                agency.label = agency.AgencyName + " (" + agency.Abbreviation + ")";
                agency.value = agency.AgencyNumber
            })
            this.setState({
                agencyOptions: agencies
            })
        })
    }

    // RETRIEVE PATRONS FOR A BILL
    getPatrons(billID, chamberCode) {
        this.props.actions.getPatronList(billID).then(() => {
            let senatePatronsList = this.props.patrons.senatePatronsList;
            let housePatronsList = this.props.patrons.housePatronsList;
            let chiefPatronsList = this.props.patrons.chiefPatronsList;
            let patronList = this.props.patrons.patronList;
            let originalPatronList = this.props.patrons.patronList;
            if (chamberCode === 'H' && chiefPatronsList && chiefPatronsList.length > 1) {
                for (let i = 1; i < chiefPatronsList.length; i++) {
                    if (chiefPatronsList[i].ChamberCode === 'S') {
                        senatePatronsList.unshift(chiefPatronsList[i]);
                    } else {
                        housePatronsList.unshift(chiefPatronsList[i]);
                    }
                    chiefPatronsList.splice(i, 1);
                    i--;
                }
            }

            housePatronsList.sort((a, b) => { return a.Sequence > b.Sequence ? 1 : b.Sequence > a.Sequence ? -1 : a.PatronDisplayName > b.PatronDisplayName ? 1 : -1 });
            senatePatronsList.sort((a, b) => { return a.Sequence > b.Sequence ? 1 : b.Sequence > a.Sequence ? -1 : a.PatronDisplayName > b.PatronDisplayName ? 1 : -1 });

            this.setState({
                senatePatronsList,
                housePatronsList,
                chiefPatronsList,
                patronList,
                originalPatronList,
                patronIsLoaded: true
            }, () => {
                if (this.props.location.state && this.props.location.state.expandPatrons && chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1) {
                    this.toggleShowData('slidePatron');
                }
            })
        }
        )
    }

    // RETRIEVE BILL SUMMARIES
    getBillSummary(billNumber, sessionCode) {
        const params = '?sessionCode=' + sessionCode + '&legislationNumber=' + billNumber;
        this.props.actions.getBillSummary(params).then(() => {
            this.setState({
                summariesList: this.props.bills.billSummary.sort((a, b) => { return b.SummaryVersionID - a.SummaryVersionID }),
                summaryIsLoaded: true
            });
        });
    }

    // RETRIEVE THE BILL HISTORY
    getBillHistory(legislationId, sessionCode) {
        let partner = false;
        let partnerEditor = false;

        if (this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR)) {
            partner = true;
            partnerEditor = true;
        } else if (this.props.login.userClaims.resources.find(resource => resource === BILL_EVENT_VIEWER)) {
            partner = true;
        }

        this.setState({
            historyIsLoaded: false
        }, () => {
            this.props.actions.getBillHistory("?LegislationId=" + legislationId + "&sessionCode=" + sessionCode, partner).then(() => {
                if (this.props.bills.billHistory.length > 0) {
                    let billHistoryWithIDs = [];
                    try {
                        this.props.bills.billHistory.forEach((x) => {
                            if (x.BillHistoryReferences) {
                                x.LegislationTextID = x.BillHistoryReferences.find(y => y.LegislationTextID && y.ParentLegislationTextID) ? x.BillHistoryReferences.find(y => y.LegislationTextID && y.ParentLegislationTextID).LegislationTextID : x.BillHistoryReferences.find(y => y.LegislationTextID)?.LegislationTextID ?? 0
                                x.ParentLegislationTextID = x.BillHistoryReferences.find(x => x.ParentLegislationTextID)?.ParentLegislationTextID ?? 0
                            }
                            billHistoryWithIDs.push(x)
                        })
                    } catch (err) {
                        billHistoryWithIDs = this.props.bills.billHistory;
                    }

                    this.setState({
                        billHistory: billHistoryWithIDs,
                        collapsedEventReferences: new Array(this.props.bills.billHistory.length).fill(false),
                        historyIsLoaded: true,
                    });
                } else {
                    //The bill cannot be found. Everything has stopped loading so set them to true. A message will be displayed to the user that the bill was not found
                    this.setState({
                        billDataIsLoaded: true,
                        patronIsLoaded: true,
                        historyIsLoaded: true,
                        billData: ''
                    });
                }
            });
        })
    }

    // RETRIEVE THE BILL DETAILS
    getBillDetails(billId, sessionCode) {
        const params = {
            SessionCode: sessionCode,
            LegislationNumbers: [{ LegislationNumber: billId }],
        };

        this.props.actions.getBillList(params).then(() => {
            if (this.props.bills.billList[0]) {
                this.setState({
                    billData: this.props.bills.billList[0],
                    billDataIsLoaded: true,
                }, () => {
                    this.getPatrons(this.state.billData.LegislationID, this.state.billData.ChamberCode);
                    this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode);

                    this.props.actions.getBillEvents('?LegislationChamberCode=' + this.state.billData.ChamberCode)
                        .then(() => {
                            let billEvents = [...this.props.bills.billEvents];
                            billEvents.forEach(evt => {
                                evt.label = evt.LegislationDescription;
                                evt.value = `${evt.LegislationEventTypeID}-${evt.IsPassed}`
                            });
                            this.setState({
                                billEvents: billEvents
                            });
                        });
                });
            } else {
                //The bill cannot be found. Everything has stopped loading so set them to true. A message will be displayed to the user that the bill was not found
                this.setState({
                    billDataIsLoaded: true,
                    patronIsLoaded: true,
                    historyIsLoaded: true,
                    billData: ''
                });
            }
        });
    }

    // RETRIEVE THE VERSIONS
    getBillVersions(billNumber, sessionCode) {
        this.props.actions.getBillVersionByBillNumber("?sessionCode=" + sessionCode + "&billNumber=" + billNumber)
            .then(() => {
                this.setState({
                    versionList: this.props.bills.billVersion
                })
            })
    }

    getReconsiderationEvents(params) {
        params = '?ReconsiderationAction=' + params + '&LegislationID=' + this.state.billData.LegislationID;

        this.props.actions.getLegislationEventsByLegislationId(params)
            .then(() => {
                this.setState({
                    reconsiderationEvents: this.props.bills.legislationEventsById
                });
            })
    }

    // TOGGLE HISTORY FORM
    toggleEditContent() {
        this.setState(state => ({
            editingHistory: !state.editingHistory
        }), () => {
            //some browsers do not support the :has() css selector, which is how we remove (i.e. set display: none) the footer-wrapper when editing events.
            //in these instances, we rely on the below js to accomplish the same.
            const footer = document.getElementsByClassName("footer-wrapper");
            if (footer && footer[0]) {
                const unsupportedBrowser = (this.state.editingHistory && window.getComputedStyle(footer[0]).display === 'block') || (!this.state.editingHistory && footer[0].style.display === 'none');
                if (unsupportedBrowser) {
                    if (this.state.editingHistory) {
                        footer[0].style.display = 'none';
                    } else {
                        footer[0].style.display = '';
                    }
                }
            }
        });
    }

    // TOGGLE SHOW 'ALL' SLIDEDOWNS
    toggleShowData(slide) {
        this.setState(prevState => ({
            [slide]: !prevState[slide]
        }));
    }

    // TOGGLE THE INFO TOOLTIP
    toggleShowTooltip() {
        this.setState(state => ({
            toolTip: !state.toolTip
        }));
    }

    togglehideAllEvents() {
        this.setState({
            hideAllEvents: !this.state.hideAllEvents
        })
    }

    toggleHistoryOrder() {
        this.setState({
            defaultHistoryOrder: !this.state.defaultHistoryOrder
        })
    }

    toggleEventReferenceCollapse(index) {
        let collapsedEventReferences = [...this.state.collapsedEventReferences];
        collapsedEventReferences[index] = !collapsedEventReferences[index];

        this.setState({
            collapsedEventReferences: collapsedEventReferences
        })
    }

    toggleEventReferenceCollapseAll() {
        let opposite = !this.state.collapseAll;
        let collapsedEventReferences = new Array(this.state.collapsedEventReferences.length).fill(opposite);

        this.setState({
            collapseAll: opposite,
            collapsedEventReferences: collapsedEventReferences
        })
    }

    toggleEventReferenceEdit(legislationEventId, referenceId) {
        let billHistory = [...this.state.billHistory];
        let event = billHistory.find(x => x.LegislationEventID === legislationEventId);

        //Force any currently open eventReference form to close
        if (this.state.openEvent !== undefined && this.state.openEvent.LegislationEventID !== legislationEventId) {
            let openEvent = { ...this.state.openEvent };
            if (openEvent.BillHistoryReferences.find(x => x.editing)) {
                openEvent.BillHistoryReferences.find(x => x.editing).editing = false;
            }
            if (openEvent.BillHistoryReferences && openEvent.BillHistoryReferences.find(x => x.parenting)) {
                openEvent.BillHistoryReferences.find(x => x.parenting).parenting = false;
            }
            if (billHistory.find(x => x.creating)) {
                billHistory.find(x => x.creating).creating = false;
            }
        }

        let reference = { ...event.BillHistoryReferences.find(x => { return x.ReferenceID === referenceId && x.ActionReferenceType === "HTML" }) }
        reference.editing = event.BillHistoryReferences.find(x => x.ReferenceID === referenceId && x.ActionReferenceType === "HTML").editing ? false : true;

        event.BillHistoryReferences.splice(event.BillHistoryReferences.findIndex(x => x.ReferenceID === referenceId && x.ActionReferenceType === "HTML"), 1, reference)
        billHistory.splice(billHistory.findIndex(x => x.LegislationEventID === legislationEventId), 1, event);

        this.setState({
            billHistory: billHistory,
            eventReferenceValue: this.state.versionList.find(x => x.ReferenceID === event.BillHistoryReferences.find(x => x.ReferenceID === referenceId && x.ActionReferenceType === "HTML").ReferenceID),
            openEvent: event
        })
    }

    handleEventReferenceChange(value) {
        this.setState({
            eventReferenceValue: value
        })
    }

    toggleEventReferenceCreate(legislationEventId) {
        let billHistory = [...this.state.billHistory];
        let event = billHistory.find(x => x.LegislationEventID === legislationEventId)

        //Force any currently open eventReference form to close
        if (this.state.openEvent !== undefined && this.state.openEvent.LegislationEventID !== legislationEventId) {
            let openEvent = { ...this.state.openEvent };
            if (openEvent.BillHistoryReferences && openEvent.BillHistoryReferences.find(x => x.editing)) {
                openEvent.BillHistoryReferences.find(x => x.editing).editing = false;
            }
            if (openEvent.BillHistoryReferences && openEvent.BillHistoryReferences.find(x => x.parenting)) {
                openEvent.BillHistoryReferences.find(x => x.parenting).parenting = false;
            }
            if (billHistory.find(x => x.creating)) {
                billHistory.find(x => x.creating).creating = false;
            }
        }

        event.creating = event.creating ? false : true;
        billHistory.splice(billHistory.findIndex(x => x.LegislationEventID === legislationEventId), 1, event);

        this.setState({
            billHistory: billHistory,
            eventReferenceValue: "",
            openEvent: event
        })
    }

    toggleEventReferenceParent(legislationEventId) {
        let billHistory = [...this.state.billHistory];
        let event = billHistory.find(x => x.LegislationEventID === legislationEventId)

        //Force any currently open eventReference form to close
        if (this.state.openEvent !== undefined && this.state.openEvent.LegislationEventID !== legislationEventId) {
            let openEvent = { ...this.state.openEvent };
            if (openEvent.BillHistoryReferences && openEvent.BillHistoryReferences.find(x => x.editing)) {
                openEvent.BillHistoryReferences.find(x => x.editing).editing = false;
            }
            if (openEvent.BillHistoryReferences && openEvent.BillHistoryReferences.find(x => x.parenting)) {
                openEvent.BillHistoryReferences.find(x => x.parenting).parenting = false;
            }
            if (billHistory.find(x => x.creating)) {
                billHistory.find(x => x.creating).creating = false;
            }
        }

        event.parenting = event.parenting ? false : true;
        billHistory.splice(billHistory.findIndex(x => x.LegislationEventID === legislationEventId), 1, event);

        this.setState({
            billHistory: billHistory,
            eventReferenceValue: "",
            openEvent: event
        })
    }

    createEventReference(legislationEventId, eventReferenceValue) {
        let event = this.state.billHistory.find(x => x.LegislationEventID === legislationEventId);

        let billHistoryReference = {
            ActionReferenceType: "PDF",
            ActionReferenceTypeID: 9,
            EventReferenceID: 0,
            LegislationEventID: event.LegislationEventID,
            LegislationTextID: eventReferenceValue.LegislationTextID,
            ModificationDate: moment(),
            ReferenceID: eventReferenceValue.LegislationTextID,
            ReferenceText: eventReferenceValue.Version,
            ReferenceTypeID: 2,
            Sequence: event.BillHistoryReferences ? event.BillHistoryReferences.length : 0,
            ParentLegislationTextID: 0
        }

        this.props.actions.saveBillEventReferences({ BillHistoryReferences: [billHistoryReference] })
            .then(() => {
                this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode)
            })
    }

    toggleDeleteEventReferenceModal(legislationEventId, eventReferenceIndex) {
        let eventReference = legislationEventId ? { ...this.state.billHistory.find(x => x.LegislationEventID === legislationEventId).BillHistoryReferences[eventReferenceIndex] } : false;

        this.setState({
            showDeleteEventReferenceModal: this.state.showDeleteImpactStatementModal ? false : eventReference
        })
    }

    deleteEventReference() {
        let eventReference = { ...this.state.showDeleteEventReferenceModal }

        eventReference.LegislationTextID = 0;

        this.props.actions.saveBillEventReferences({ BillHistoryReferences: [eventReference] })
            .then(() => {
                this.setState({
                    showDeleteEventReferenceModal: false
                }, () => {
                    this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode)
                })
            })
    }

    setEventReferenceParent(legislationEventId, eventReferenceValue) {
        let event = this.state.billHistory.find(x => x.LegislationEventID === legislationEventId);

        //If we're adding the a billHistoryReference for a parent version to an amendment-like version then update the child with the parent's legislationTextId to create the relationship 
        if (event.BillHistoryReferences && event.BillHistoryReferences.find(x => x.ParentLegislationTextID == 0 && PARENT_ELIGIBLE_EVENTS.some(y => x.ReferenceText.toLowerCase().includes(y)))) {
            let childBillHistoryReference = { ...event.BillHistoryReferences.find(x => x.ParentLegislationTextID == 0 && PARENT_ELIGIBLE_EVENTS.some(y => x.ReferenceText.toLowerCase().includes(y))) };
            childBillHistoryReference.ParentLegislationTextID = eventReferenceValue.LegislationTextID;

            this.props.actions.saveBillEventReferences({ BillHistoryReferences: [childBillHistoryReference] })
                .then(() => {
                    this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode)
                })
        }
    }

    saveEventReference(legislationEventId, eventReferenceIndex, eventReferenceValue) {
        let event = this.state.billHistory.find(x => x.LegislationEventID === legislationEventId);
        event.BillHistoryReferences[eventReferenceIndex].editing = false;

        let billHistoryReference = {
            ActionReferenceType: event.BillHistoryReferences[eventReferenceIndex].ActionReferenceType,
            ActionReferenceTypeID: event.BillHistoryReferences[eventReferenceIndex].ActionReferenceTypeID,
            EventReferenceID: event.BillHistoryReferences[eventReferenceIndex].EventReferenceID,
            LegislationEventID: event.LegislationEventID,
            LegislationTextID: eventReferenceValue.LegislationTextID,
            ModificationDate: moment(),
            ReferenceID: eventReferenceValue.LegislationTextID,
            ReferenceText: eventReferenceValue.Version,
            ReferenceTypeID: event.BillHistoryReferences[eventReferenceIndex].ReferenceTypeID,
            Sequence: event.BillHistoryReferences[eventReferenceIndex].Sequence,
            ParentLegislationTextID: event.BillHistoryReferences[eventReferenceIndex].ParentLegislationTextID,
        }

        this.props.actions.saveBillEventReferences({ BillHistoryReferences: [billHistoryReference] })
            .then(() => {
                this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode)
            })
    }

    handleEventChange(organizedEvents, callback) {
        this.setState({
            organizedEvents: organizedEvents
        }, () => {
            if (callback) {
                callback();
            }
        });
    }

    saveEvents(eventsToSave, callback) {
        if (eventsToSave.length > 0) {
            this.props.actions.saveBillEvent({ LegislationEvents: eventsToSave })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Events Saved", type: "success" }]);
                    this.props.actions.getBillHistory("?LegislationId=" + this.state.billData.LegislationID + "&sessionCode=" + this.state.billData.SessionCode, true)
                        .then(() => {
                            this.setState({
                                billHistory: this.props.bills.billHistory,
                            }, () => callback(true))
                        });
                }).catch(err => {
                    console.log(err)
                    if (err === 'Aborted') {
                        return;
                    }
                    let msg;
                    if (err) {
                        try {
                            const errJson = JSON.parse(err);
                            if (errJson && errJson.Name) {
                                msg = errJson.Name
                            }
                        } catch (e) { /*do nothing*/ }
                    }
                    this.props.actions.makeToast([{ message: msg && msg.toLowerCase().includes("unable to delete referral") ? msg : "Events Save Failed", type: "failure" }]);
                    this.props.actions.getBillHistoryByBillID('?legislationID=' + this.state.billData.LegislationID + "&sessionCode=" + this.state.billData.SessionCode, true)
                        .then(() => {
                            this.setState({
                                billHistory: this.props.bills.billHistory,
                            }, () => callback(false))
                        });
                })
        } else {
            // If there  are no events to save then just show the save succesful banner after a second to give the illusion something happened.
            setTimeout(() => {
                this.props.actions.makeToast([{ message: "Events Saved", type: "success" }]);
                callback(false)
            }, 1000)
        }
    }

    toggleStatementForm(statementDescription, documentCode) {
        if (!this.state.displayStatementForm) {
            this.setState({
                displayStatementForm: true,
                statementDescription: statementDescription,
                statementDocumentcode: documentCode
            });
        } else {
            this.setState({
                displayStatementForm: false,
                statementDescription: "",
                statementDocumentcode: ""
            });
        }
    }

    closeStatementForm() {
        this.setState({
            displayStatementForm: false
        }, () => {
            //Refresh the page to show the new impact statement in the version list
            this.setupPage(this.state.billData.SessionCode, this.state.billData.LegislationNumber);
        })
    }

    saveDescription() {
        let saving = { ...this.state.saving };
        saving[DESCRIPTION] = true;
        this.setState({
            saving
        }, () => {
            //Partner get bill request to get the mod date
            this.props.actions.getBill(this.state.billData.LegislationID, true)
                .then(() => {
                    let modifiedBillData = { ...this.props.bills.bill };
                    modifiedBillData.Description = this.state.description;

                    this.props.actions.saveBill({ LegislationList: [modifiedBillData] })
                        .then(() => {
                            this.props.actions.makeToast([{ message: "Description Saved", type: "success" }]);
                            let newBillData = { ...this.state.billData }
                            newBillData.Description = this.state.description;
                            let editing = { ...this.state.editing };
                            editing[DESCRIPTION] = false;
                            saving[DESCRIPTION] = false;
                            this.setState({
                                editing,
                                saving,
                                billData: newBillData
                            });
                        }).catch(err => {
                            if (err === 'Aborted') {
                                return;
                            }
                            this.props.actions.makeToast([{ message: "Description Save Failed", type: "failure" }]);
                            let editing = { ...this.state.editing };
                            editing[DESCRIPTION] = false;
                            saving[DESCRIPTION] = false;
                            this.setState({
                                editing: editing,
                                saving: saving
                            });
                        });
                })
        })
    }

    toggleDeleteSummaryModal(summary, summaryIndex) {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            summaryToDelete: { ...summary, index: summaryIndex }
        })
    }

    saveSummary(index, deletion) {
        let saving = { ...this.state.saving };
        if (!saving[SUMMARY]) {
            saving[SUMMARY] = {};
        }
        saving[SUMMARY][index] = true;
        this.setState({
            saving
        }, () => {
            let summariesList = [...this.state.summariesList];
            //Partner get summary request to get the mod date
            this.props.actions.getBillSummary('/' + summariesList[index].LegislationSummaryID, true)
                .then(() => {
                    let modifiedSummaryData = [...this.props.bills.billSummary];
                    if (deletion) {
                        //Turn IsActive and IsPublic is false, and that will prevent the DB from turning one or the other true in the future
                        modifiedSummaryData[0].IsActive = false;
                        modifiedSummaryData[0].IsPublic = false;
                    } else {
                        modifiedSummaryData[0].Summary = this.state.summary[index];
                    }
                    this.props.actions.saveBillSummary({ SummaryList: modifiedSummaryData })
                        .then(() => {
                            this.props.actions.makeToast([{ message: "Summary " + (deletion ? "Removed" : "Saved"), type: "success" }]);
                            let editing = { ...this.state.editing };
                            let summary = { ...this.state.summary };
                            if (deletion) {
                                //remove from the UI and reset the editing/saving/summary values to avoid indexing problems
                                this.toggleDeleteSummaryModal();
                                summariesList.splice(index, 1);
                                saving = {};
                                editing = {};
                                summary = {};
                            } else {
                                summariesList[index] = this.props.bills.billSummarySave[0];
                                saving[SUMMARY][index] = false;
                                if (editing[SUMMARY] && editing[SUMMARY][index]) {
                                    editing[SUMMARY][index] = false;
                                }
                            }
                            this.setState({
                                summariesList,
                                summary,
                                editing,
                                saving
                            });
                        }).catch(err => {
                            if (err === 'Aborted') {
                                return;
                            }
                            console.error(err)
                            this.props.actions.makeToast([{ message: "Summary Save Failed", type: "failure" }]);
                            let editing = { ...this.state.editing };
                            let saving = { ...this.state.saving };
                            let summary = { ...this.state.summary };
                            editing = {};
                            saving = {};
                            summary = {};
                            this.setState({
                                summary,
                                editing: editing,
                                saving: saving
                            });
                        });
                })
        })
    }

    toggleEdit(key, value, index) {
        let editing = { ...this.state.editing };
        if (key === SUMMARY) {
            if (!editing[key]) {
                editing[key] = {};
            }
            editing[key][index] = !editing[key][index];
            let keyState = { ...this.state[key] };
            keyState[index] = value;
            this.setState({
                editing,
                [key]: keyState
            })
        } else {
            editing[key] = !editing[key];
            this.setState({
                editing,
                [key]: value
            })
        }
    }

    handleChange(key, e, index) {
        if (key === SUMMARY) {
            let keyState = { ...this.state[key] };
            keyState[index] = e;
            this.setState({
                [key]: keyState
            })
        } else {
            this.setState({
                [key]: e.target.value
            })
        }
    }

    checkForDuplicates(summary) {
        let results = summary.match(/[H|S][B|J|R][\s|&nbsp;]+[0-9]+/g);
        if (results) {
            //.trim() and .replace(" ", "") both didn't work, even after being run through .toString(). I'm just glad this works. - JGB
            results.forEach((match) => {
                let breaklessMatch = match.replace('&nbsp;', ' ')
                let billNum = breaklessMatch.slice(0, 2) + breaklessMatch.slice(3);
                let link = `<a href="/bill-details/` + this.state.billData.SessionCode + `/` + billNum + `">` + breaklessMatch + `</a>`;
                summary = summary.replace(match, link);
            });
            return summary
        } else {
            return summary
        }
    }

    handleWatchlistChange(val) {
        this.setState({
            selectedWatchlists: val
        });
    }

    handleSaveWatchlistss() {
        let watchlists = JSON.parse(JSON.stringify(this.state.selectedWatchlists));
        this.addToWatchlists(watchlists, (saveResultCollections) => {
            let showPopup = { ...this.state.showPopup };

            // they are adding bills to one or more watchlist(s) - we need to update the selectedWatchlists state values because their mod dates have now changed
            for (let i = 0; i < watchlists.length; i++) {
                const associatedWatchlist = saveResultCollections.find(c => c.WatchListID === watchlists[i].WatchListID);
                if (associatedWatchlist && associatedWatchlist.ModificationDate !== watchlists[i].ModificationDate) {
                    watchlists[i] = associatedWatchlist
                };
            }

            this.setState({ selectedWatchlists: [] ? watchlists : [], selectedMergeWatchlists: [], showPopup })
        });
    }

    addToWatchlists(watchlists, note) {
        let duplicatedBills = [];
        watchlists.forEach(watchlist => {
            //Replace each instance of bill with the bill details in state here
            if (watchlist.__isNew__) {
                watchlist.Name = watchlist.label;
                watchlist.Description = `Created on ${moment().tz('America/New_York').format('MM/DD/YYYY')}`;
                watchlist.WatchListLegislation = [];
                delete watchlist.label;
                delete watchlist.__isNew__;
                delete watchlist.value;
            }
            // Make sure the bill isn't already a part of the watchlist
            if (!watchlist.WatchListLegislation.find(leg => leg.LegislationID === this.state.billData.LegislationID) || watchlist.WatchListLegislation.find(leg => leg.LegislationID === this.state.billData.LegislationID).DeletionDate) {
                watchlist.WatchListLegislation.push({
                    LegislationID: this.state.billData.LegislationID,
                    LegislationNumber: this.state.billData.LegislationNumber,
                    Sessions: [{ SessionID: this.state.billData.SessionID }],
                    WatchListID: watchlist.WatchListID,
                    Note: note
                });
            } else {
                duplicatedBills.push({ "Watchlist": watchlist.Name, "LegislationNumber": this.state.billData.LegislationNumber });
            }
        })

        this.setState({
            collectionIsSaving: true
        }, () => {
            this.props.actions.saveCollections({ WatchLists: watchlists })
                .then(() => {
                    this.setState({
                        collectionIsSaving: false,
                        showWatchlistForm: false,
                        selectedWatchlists: []
                    });

                    this.getCollections("?SessionID=" + this.state.billData.SessionID)

                    if (duplicatedBills.length) {
                        this.props.actions.makeToast([{ message: duplicatedBills[0].LegislationNumber + " is already in " + (watchlists.length === 1 ? "this watchlist. " : "one or more of these watchlists. "), type: "warning", long: true }]);
                    } else {
                        this.props.actions.makeToast([{ message: this.state.billData.LegislationNumber + " was added to your watchlist" + (watchlists.length > 1 ? "s" : (" " + watchlists[0].Name)), type: "success" }]);
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        collectionIsSaving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        });
    }

    getCollections(params) {
        this.setState({
            collectionIsLoading: true
        });
        return Promise.resolve(this.props.actions.getCollections(params)
            .then(() => {
                const parsed = queryString.parse(this.props.location.search);
                const collectionIndex = this.props.collection.collections.findIndex(coll => coll.WatchListID === parseInt(parsed.collection))
                this.setState({
                    collectionIsLoading: false,
                }, () => {
                    if (collectionIndex !== -1) {
                        this.selectCollection(collectionIndex)
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return Promise.reject(err)
                }
                this.setState({
                    collectionIsLoading: false
                });
            })
        )
    }

    async submitImpactStatement(description, agencyNumber, file, documentCode) {
        let params = "?legislationNumber=" + this.props.params.billnumber
            + "&sessionCode=" + this.props.params.sessionCode
            + "&referenceNumber=" + documentCode + "F" + agencyNumber
            + "&description=" + description

        this.setState({
            statementSubmitting: true
        }, () => {
            this.props.actions.uploadImpactStatement(params, file)
                .then(() => {
                    this.setState({
                        statementSubmitting: false
                    }, () => {
                        this.closeStatementForm();
                    })
                    this.props.actions.makeToast([{ message: "Impact Statement Upload Successful", type: "success" }]);
                })
                .catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    this.setState({
                        statementSubmitting: false
                    });
                    this.props.actions.makeToast([{ message: "Impact Statement Upload Failed", type: "failure" }]);
                })
        })
    }

    handleNoteTextChange(e) {
        this.setState({
            noteText: e.target.value
        })
    }

    handleNoteWatchlistChange(value) {
        this.setState({
            noteWatchlists: value,
            noteText: value && value.length === 1 && value[0].WatchListLegislation ? value[0].WatchListLegislation.find(x => x.LegislationID === this.state.billData.LegislationID)?.Note ?? "" : ""
        })
    }

    toggleNotesForm() {
        this.setState({
            showNoteForm: !this.state.showNoteForm,
        })
    }

    handleSaveWatchlists() {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            let selectedWatchlists = [...this.state.noteWatchlists];
            selectedWatchlists.forEach(watchlist => {
                if (watchlist.__isNew__) {
                    watchlist.Name = watchlist.label;
                    watchlist.Description = `Created on ${moment().format('MM/DD/YYYY')}`;
                    watchlist.WatchListLegislation = [];
                    delete watchlist.label;
                    delete watchlist.__isNew__;
                    delete watchlist.value;
                }

                const watchlistBillIndex = watchlist.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                if (watchlistBillIndex > -1) {
                    watchlist.WatchListLegislation[watchlistBillIndex].Note = this.state.noteText;
                } else {
                    watchlist.WatchListLegislation.push({
                        LegislationID: this.state.billData.LegislationID,
                        LegislationNumber: this.state.billData.LegislationNumber,
                        Sessions: [{ SessionID: this.state.billData.SessionID }],
                        WatchListID: watchlist.WatchListID,
                        Note: this.state.noteText
                    })
                }
            })

            this.props.actions.saveCollections({ WatchLists: selectedWatchlists })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Watchlist(s) Updated", type: "success" }]);
                    this.setState({
                        saving: false,
                        showNoteForm: !this.state.showNoteForm,
                        noteWatchlists: [],
                        noteText: "",
                    });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        saving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        })
    }

    handleRemoveWatchlists() {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            let selectedWatchlists = [...this.state.noteWatchlists];
            selectedWatchlists.forEach(watchlist => {
                const watchlistBillIndex = watchlist.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                watchlist.WatchListLegislation[watchlistBillIndex].DeletionDate = new Date();
            })

            this.props.actions.saveCollections({ WatchLists: selectedWatchlists })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Watchlist(s) Removed", type: "success" }]);
                    this.setState({
                        saving: false,
                        showNoteForm: !this.state.showNoteForm,
                        noteWatchlists: [],
                        noteText: "",
                    });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        saving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        })
    }

    toggleWatchlistList() {
        this.setState({
            showWatchlistList: !this.state.showWatchlistList
        })
    }

    togglePatronModal() {
        this.props.history.push({
            pathname: `/bill-details/${this.state.billData.SessionCode}/${this.state.billData.LegislationNumber}/text/${this.state.billHistory.find(x => x.Status === "Introduced")?.ReferenceID}`,
            state: { patronUpdate: true }
        })
    }

    toggleReportMaker() {
        this.setState({
            showReportMaker: !this.state.showReportMaker
        })
    }

    addCommitteeLink(historyItem) {
        let linkedDescription = historyItem.Description;
        let committee, subcommittee;

        //Have to do two replaces below so we don't replace the dashes in the hrefs with non-breaking dashes that won't work 
        try {
            if (historyItem.CommitteeName && !historyItem.ParentCommitteeName) {
                committee = this.state.committeeList.find(x => x.Name === historyItem.CommitteeName && x.ChamberCode === historyItem.ChamberCode);

                linkedDescription = linkedDescription.replace(/-/g, '\u2011');
                linkedDescription = linkedDescription.replace(historyItem.CommitteeName.replace(/-/g, '\u2011'), '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + committee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + committee.Name.replace(/-/g, '\u2011') + '</a>')

                return linkedDescription;
            } else if (historyItem.ReferenceType === "Subcommittee") {
                committee = this.state.committeeList.find(x => x.Name === historyItem.ParentCommitteeName && x.ChamberCode === historyItem.ChamberCode)
                //Handle bad data where they gave me the subcommittee lookup info instead of the committee
                subcommittee = committee.ParentCommitteeID ? committee : this.state.committeeList.find(x => x.ParentCommitteeID === committee.CommitteeID && x.Name.includes(historyItem.CommitteeName));

                linkedDescription = linkedDescription.replace(/-/g, '\u2011');

                if (subcommittee && linkedDescription.includes(subcommittee.Name)) {
                    linkedDescription = linkedDescription.replace(historyItem.CommitteeName.replace(/-/g, '\u2011'), '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a>');
                } else if (subcommittee.ParentCommitteeID === 26 /* Senate Finance and Appropriations has un-matchable language in history descriptions */) {
                    linkedDescription = linkedDescription.replace(new String("FIN & APP sub: " + subcommittee.Name.slice(subcommittee.Name.indexOf(":") + 1).trim()).replace(/-/g, '\u2011'), 'FIN & APP sub: <a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a>');
                } else if (subcommittee.ParentCommitteeID === 9 /* House Education has un-matchable language in history descriptions */) {
                    linkedDescription = linkedDescription.replace(new String("Educ sub: " + subcommittee.Name.slice(subcommittee.Name.indexOf(":") + 1).trim()).replace(/-/g, '\u2011'), 'Educ sub: <a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a>');
                } else if (subcommittee && linkedDescription.includes(subcommittee.Name.slice(subcommittee.Name.indexOf(":") + 1))) {
                    linkedDescription = linkedDescription.replace(historyItem.CommitteeName.replace(/-/g, '\u2011'), '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a>');
                } else if (subcommittee && linkedDescription.replace(/\s/g, '').toLowerCase().includes(subcommittee.Name.slice(1).replace(/\s/g, '').toLowerCase())) {
                    linkedDescription = linkedDescription.replace(historyItem.CommitteeName.replace(/-/g, '\u2011'), '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a>');
                } else if (subcommittee && linkedDescription.includes("subcommittee")) {
                    linkedDescription = linkedDescription.replace("subcommittee", '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a> subcommittee');
                } else if (subcommittee && linkedDescription.includes("Subcommittee")) {
                    linkedDescription = linkedDescription.replace("Subcommittee", '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + historyItem.CommitteeName.replace(/-/g, '\u2011') + '</a> ' + (historyItem.CommitteeName.toLowerCase().includes("subcommittee") ? "" : 'subcommittee'));
                }

                return linkedDescription;
            } else {
                return historyItem.Description;
            }
        } catch (err) {
            console.log(err)
            return historyItem.Description;
        }
    }

    toggleDisplayStatementForm() {
        this.setState({
            displayStatementForm: !this.state.displayStatementForm
        })
    }

    toggleDeleteImpactStatementModal(value) {
        this.setState({
            showDeleteImpactStatementModal: this.state.showDeleteImpactStatementModal ? false : value
        })
    }

    toggleVersionList() {
        this.setState({
            showVersions: !this.state.showVersions
        })
    }

    deleteImpactStatement() {
        const params = "?deletionDate=" + moment().format("MM/DD/YYYY").toString() + "&fileID=" + this.state.showDeleteImpactStatementModal.FileID + "&fileUrl=" + this.state.showDeleteImpactStatementModal.BillHistoryLink
        this.props.actions.deleteImpactStatement(params)
            .then(() => {
                this.setState({
                    showDeleteImpactStatementModal: false
                }, () => {
                    this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode)
                })
                this.props.actions.makeToast([{ message: "Imapct Statement Deleted", type: "success" }]);
            })
            .catch((err) => {
                this.props.actions.makeToast([{ message: "Impact Statement Delete Failed", type: "failure" }]);
            })
    }

    hasAccess() {
        return this.props.login.userClaims.roles.some(x => ACCESS_ROLES.includes(x));
    }

    render() {
        const { sessionData, summariesList, billData, senatePatronsList, housePatronsList, chiefPatronsList, editing, description, saving } = this.state;

        let billSummary = '';
        if (summariesList.length > 0) {
            billSummary = summariesList[0];
        }
        const sessionHeader = sessionData && !isStatic ? sessionData.SessionYear + ' ' + sessionData.DisplayName : '';
        const billHeader = billData && !isStatic ? <React.Fragment>
            <div style={{ display: "grid", gridTemplateColumns: "0px auto 0px 120px 1fr", marginTop: "10px" }}>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1) > -1)
                    ? <div />/* <div className="nav-arrow-left" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1)].LegislationNumber)}></div> */
                    : <div />
                }
                <span style={{ height: "22px" }}>{billData.LegislationNumber}</ span>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1) < this.props.bills.storedFullLegislationList.length && this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) > -1)
                    ? <div />/* <div className="nav-arrow-right" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1)].LegislationNumber)}></div> */
                    : <div />
                }
                {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR)
                    ? <button type="button" className="button small-button remove-from-print" style={{ fontSize: '0.8em', height: "28px" }} onClick={this.toggleEditContent}>Edit History</button>
                    : <div />
                }
                <div>
                    <span className='status-text'>{"Status: " + billData.LegislationStatus}</span>
                </div>
            </div>
            <span>{renderHTML(billData.Description || '')}</span>
            {this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) && <a className="icon edit" style={{ marginLeft: "5px" }} onClick={() => this.toggleEdit(DESCRIPTION, this.state.billData.Description)}></a>}
        </React.Fragment> : '';

        const billHeaderEditor = <div className="bill-description-editor">
            <div style={{ display: "inline-flex", marginTop: "5px" }}>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1) > -1)
                    ? <div className="nav-arrow-left" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1)].LegislationNumber)}></div>
                    : <div />
                }
                <span style={{ height: "22px" }}>{billData.LegislationNumber}</ span>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1) < this.props.bills.storedFullLegislationList.length && this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) > -1)
                    ? <div className="nav-arrow-right" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1)].LegislationNumber)}></div>
                    : <div />
                }
                {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) &&
                    <button type="button" className="button small-button remove-from-print" style={{ fontSize: '0.8em', height: "28px" }} onClick={this.toggleEditContent}>Edit History</button>
                }
            </div>
            <br />
            <input value={description} onChange={(e) => this.handleChange(DESCRIPTION, e)} disabled={saving[DESCRIPTION]} />
            {saving[DESCRIPTION]
                ? <div className="small-spinner"></div>
                : <div style={{ display: "inline-flex" }}><a className="icon save" onClick={() => this.saveDescription()}></a>
                    <a className="icon delete" onClick={() => this.toggleEdit(DESCRIPTION)}></a></div>
            }
        </div>;

        const formatSummaryVersion = (billSummary) => (
            billSummary.SummaryVersion.toLowerCase().split("").map((x, i) => { return billSummary.SummaryVersion[i - 1] === " " || i === 0 ? x.toUpperCase() : x })
        )

        const billSummaryEditor = index => <div className="bill-summary-editor">
            <Editor
                disabled={saving[SUMMARY] && saving[SUMMARY][index]}
                value={this.state.summary[index]}
                init={{
                    browser_spellcheck: true,
                    height: 350,
                    plugins: 'link paste save lists preview searchreplace pagebreak code table',
                    toolbar: 'undo redo | bold italic strikethrough | alignleft aligncenter alignright',
                    skin: false,
                    valid_children: '+body[style]',
                    content_css: false,
                    content_style: 'table { border-collapse: collapse; border: 1px solid #FFFFFF }' + 'td { padding: 12px 0px }',
                    formats: {
                        sumtext: {
                            block: 'p', attributes: { class: 'sumtext' }
                        }
                    },
                    style_formats: [
                        { title: "Sumtext", format: "sumtext" },
                    ],
                }}
                onEditorChange={content => this.handleChange(SUMMARY, content, index)}
            />
            {saving[SUMMARY] && saving[SUMMARY][index]
                ? <div className="small-spinner" />
                : <React.Fragment><a className="icon save" onClick={() => this.saveSummary(index)}></a>
                    <a className="icon delete" onClick={() => this.toggleEdit(SUMMARY, null, index)}></a></React.Fragment>
            }
        </div>;

        if (!this.state.billDataIsLoaded) {
            return (
                <div><LoaderComponent className="center-spinner" data={false} /></div>
            )
        } else if (!billData) {
            //Bill Data has been loaded but if it is empty then there have been zero results returned from the server
            return (<p>Bill data could not be found</p>)
        }

        return (
            <div id="bill-details" className="bill-theme public-details inner-grid" ref={el => (this.componentRef = el)}>
                {this.state.showReportMaker &&
                    <ReportMaker
                        toggleReportMaker={this.toggleReportMaker}
                        billList={[this.state.billData]}
                        collections={this.state.noteWatchlists}
                        selectedCollection={{ Name: this.state.billData.LegislationNumber + " Report" }}
                        autoReport={false}
                        reportTitle={this.state.billData.LegislationNumber + " Report"}
                    />
                }
                {this.state.showDeleteImpactStatementModal &&
                    <div className='schedule-modal'>
                        <div className='schedule-modal-content' style={{ height: "95px", width: "500px" }}>
                            <p style={{ fontSize: "16px" }}>Are you sure you want to delete this impact statement?</p>
                            <div>
                                <button style={{ float: "right" }} className='button danger' onClick={() => this.deleteImpactStatement()}>Delete</button>
                                <button style={{ float: "right", marginRight: "10px" }} className='button secondary' onClick={() => this.toggleDeleteImpactStatementModal(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                }
                {this.state.showDeleteEventReferenceModal &&
                    <div className='schedule-modal'>
                        <div className='schedule-modal-content' style={{ height: "95px", width: "500px" }}>
                            <p style={{ fontSize: "16px" }}>Are you sure you want to delete this reference?</p>
                            <div>
                                <button style={{ float: "right" }} className='button danger' onClick={() => this.deleteEventReference()}>Delete</button>
                                <button style={{ float: "right", marginRight: "10px" }} className='button secondary' onClick={() => this.toggleDeleteEventReferenceModal(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                }
                {this.state.showDeleteModal &&
                    <div className='schedule-modal'>
                        <div className='schedule-modal-content'>
                            <div className='grid-wrapper'>
                                <div className='inner-grid eight-one-and-one'>
                                    <span>Are you sure you want to delete this summary ({formatSummaryVersion(this.state.summaryToDelete)})?</span>
                                    {saving[SUMMARY] && saving[SUMMARY][this.state.summaryToDelete.index]
                                        ? <div className="small-spinner" />
                                        : <button className='button primary' onClick={() => this.saveSummary(this.state.summaryToDelete.index, true)}>Yes</button>
                                    }
                                    <button className='button secondary' onClick={() => this.toggleDeleteSummaryModal()}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!isStatic &&
                    <div className='session-header-wrapper' style={{ borderBottom: "1px solid #CCC", display: "inline-flex" }}>
                        <h2 style={{ marginBottom: "5px", marginTop: "0", border: "0", whiteSpace: "nowrap", padding: 0 }}>{sessionHeader}</h2>
                        <div style={{ width: "100%" }} />
                        <div className={`flex-row ${!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) ? 'space-around' : 'flex-end'}`} style={{ marginTop: "10px", height: "24px" }}>
                            <ReactToPrint
                                trigger={() => <a type="button" className="button print remove-from-print"></a>}
                                content={() => {
                                    let printedContent = this.componentRef.cloneNode(true);
                                    //remove icons from printed document
                                    const removedContent = printedContent.getElementsByClassName('remove-from-print');
                                    for (const el of removedContent) {
                                        el.innerHTML = ''
                                    }
                                    return printedContent
                                }}
                                pageStyle={"break-inside: avoid"}
                            />
                            <button className='button primary remove-from-print report-toggle small-button' style={{ margin: "0 0 0 5px", padding: "4px", height: "24px" }} onClick={() => this.toggleReportMaker()}>Create Report</button>
                        </div>
                    </div>
                }
                {!isStatic &&
                    <div className="details-header bill-details-header new-header">
                        <h3 style={{ marginBottom: "15px" }}>{!editing[DESCRIPTION] ? billHeader : billHeaderEditor}</h3>
                    </div>
                }
                <div>
                    <div>
                        {!this.state.editingHistory && this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) && billData && !isStatic &&
                            <Collections
                                billData={billData}
                                sessionId={this.props.session.selectedSession.SessionID}
                                showNoteForm={this.state.showNoteForm}
                                toggleNotesForm={this.toggleNotesForm}
                                noteWatchlists={this.state.noteWatchlists}
                                noteText={this.state.noteText}
                                handleNoteTextChange={this.handleNoteTextChange}
                                handleNoteWatchlistChange={this.handleNoteWatchlistChange}
                                selectStyle={selectStyle}
                                handleSaveWatchlists={this.handleSaveWatchlists}
                                handleRemoveWatchlists={this.handleRemoveWatchlists}
                                saving={this.state.saving}
                            />
                        }
                        {!this.state.editingHistory &&
                            <div style={{ margin: "0" }} className={this.state['slidePatron'] ? 'parent-li slidedown-open' : 'parent-li slidedown-closed'}>
                                <div className="toggle-row">
                                    <div className="description patron-header" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        <h4 style={{ paddingRight: "10px", borderRight: chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 ? "1px solid #CCC" : "0" }}>{chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 ? "Patrons" : "Patron"}</h4>
                                        {chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 &&
                                            <div className="button-container">
                                                <label id="sr-patrons-drawer-label" className="arrow-down-label" onClick={this.toggleShowData.bind(this, 'slidePatron')}>All Patrons</label>
                                                <button aria-labelledby="sr-patrons-drawer-label" aria-expanded={!!this.state['slidePatron']} className="arrow-down" onClick={this.toggleShowData.bind(this, 'slidePatron')}>More info</button>
                                            </div>
                                        }
                                        {this.props.login.userClaims.claims.find(claim => claim.RoleName === "Admin" || (claim.Resource === PATRON_AUTHOR && claim.Scope === (this.state.billData.ChamberCode === "H" ? "House" : "Senate"))) &&
                                            <button className="button small-button remove-from-print" onClick={this.togglePatronModal}>Update Patrons</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        {!this.state.patronIsLoaded ? <LoaderComponent data={false} /> :
                            !this.state.editingHistory &&
                            <div style={{ marginBottom: "15px" }}>
                                <div className="list-desc">
                                    <p style={this.state['slidePatron'] ? { marginBottom: "0px" } : { marginBottom: "15px" }}>Introduced by: <PatronList session={sessionData} patrons={chiefPatronsList} /></p>
                                </div>
                                {this.state['slidePatron'] &&
                                    <div className="patrons-list list-desc">
                                        {this.state.billData.ChamberCode === "H"
                                            ?
                                            <React.Fragment>
                                                {housePatronsList.length > 0 && <div><span>House: </span><PatronList session={sessionData} patrons={housePatronsList} list /></div>}
                                                {senatePatronsList.length > 0 && <div><span>Senate: </span><PatronList session={sessionData} patrons={senatePatronsList} list /></div>}
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                {senatePatronsList.length > 0 && <div><span>Senate: </span><PatronList session={sessionData} patrons={senatePatronsList} list /></div>}
                                                {housePatronsList.length > 0 && <div><span>House: </span><PatronList session={sessionData} patrons={housePatronsList} list /></div>}
                                            </React.Fragment>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {!this.state.summaryIsLoaded ? <LoaderComponent data={false} /> :
                            !this.state.editingHistory &&
                            <div className="bill-details-summary">
                                <div className="list-desc">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <h4 style={{ padding: '0px 10px 0px 0px', borderRight: summariesList.length > 1 ? "1px solid #CCC" : "0" }} className={summariesList.length > 1 ? 'with-arrow' : ''}>{formatSummaryVersion(billSummary)}</h4>
                                        {summariesList.length > 1 &&
                                            <div style={{ margin: "0 0 0 10px" }} className={this.state['slideSummaries'] ? 'parent-li slidedown-open' : 'parent-li slidedown-closed'}>
                                                <div className="button-container">
                                                    <label id="sr-summaries-drawer-label" className="arrow-down-label" onClick={this.toggleShowData.bind(this, 'slideSummaries')}>All Summaries</label>
                                                    <button aria-labelledby="sr-summaries-drawer-label" aria-expanded={!!this.state['slideSummaries']} className="arrow-down" onClick={this.toggleShowData.bind(this, 'slideSummaries')}>More info</button>
                                                </div>
                                            </div>
                                        }
                                        {(!editing[SUMMARY] || !editing[SUMMARY][0]) && this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) &&
                                            <React.Fragment>
                                                <a className="icon edit" style={{ margin: "0px 7px" }} onClick={() => this.toggleEdit(SUMMARY, billSummary.Summary ? this.checkForDuplicates(billSummary.Summary) : '', 0)}></a>
                                                <a className="icon delete" onClick={() => this.toggleDeleteSummaryModal(billSummary, 0)}></a>
                                            </React.Fragment>
                                        }
                                    </div>
                                    <div className='summary-wrapper'>
                                        {!editing[SUMMARY] || !editing[SUMMARY][0]
                                            ? renderHTML(this.checkForDuplicates(billSummary.Summary) || '')
                                            : billSummaryEditor(0)
                                        }
                                    </div>
                                </div>
                                {this.state['slideSummaries'] &&
                                    <div className="list-desc" style={{ marginTop: "10px" }}>
                                        <span>
                                            {
                                                summariesList.map((summaries, i) => {
                                                    if (i > 0) {
                                                        return (
                                                            <div>
                                                                <div key={i} style={{ display: 'flex' }}> <p><strong>{summaries.SummaryVersion}</strong></p>
                                                                    {(!editing[SUMMARY] || !editing[SUMMARY][i]) && this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) &&
                                                                        <React.Fragment>
                                                                            <a className="icon edit" style={{ margin: "0px 7px" }} onClick={() => this.toggleEdit(SUMMARY, summaries.Summary ? this.checkForDuplicates(summaries.Summary) : '', i)}></a>
                                                                            <a className="icon delete" onClick={() => this.toggleDeleteSummaryModal(summaries, i)}></a>
                                                                        </React.Fragment>
                                                                    }
                                                                </div>
                                                                {!editing[SUMMARY] || !editing[SUMMARY][i] ?
                                                                    renderHTML(summaries.Summary ? this.checkForDuplicates(summaries.Summary) : '')
                                                                    :
                                                                    billSummaryEditor(i)
                                                                }
                                                            </div>
                                                        )
                                                    } else {
                                                        return false;
                                                    }

                                                })
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                        {this.props.login.userClaims.roles.find(x => x === "Admin") && this.state.showVersions &&
                            <>
                                <h4 onClick={() => this.toggleVersionList()}>Bill Versions</h4>
                                <ul style={{ paddingLeft: "0", marginTop: "0" }}>
                                    <li style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 400px", borderBottom: "1px solid #CCC", padding: "4px" }}>
                                        <strong>Description</strong>
                                        <strong>Document Code</strong>
                                        <strong>LD Number</strong>
                                        <strong>Draft Date</strong><strong />
                                        <div />
                                    </li>
                                    {this.state.versionsList && this.state.versionList.sort((a, b) => moment(a.DraftDate).isBefore(moment(b.DraftDate))).map((x, i) => {
                                        return <li style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 400px", listStyleType: "none", backgroundColor: (i % 2 === 0 ? "#FFF" : "#F7F7F7"), padding: "4px" }}>
                                            <a href={"/bill-details/" + this.state.billData.SessionCode + "/" + this.state.billData.LegislationNumber + "/text/" + x.DocumentCode}>{x.Description}</a>
                                            <span>{x.DocumentCode}</span>
                                            <span>{x.LDNumber}</span>
                                            <span>{moment(x.DraftDate).format("MM/DD/YYYY")}</span>
                                            <div />
                                        </li>
                                    })}
                                </ul>
                            </>
                        }
                        <div>
                            {this.state.displayStatementForm &&
                                <ImpactStatementForm
                                    submit={this.submitImpactStatement}
                                    isSubmitting={this.state.statementSubmitting}
                                    toggleStatementForm={this.toggleStatementForm}
                                    agencyOptions={this.state.agencyOptions}
                                    versionList={this.state.versionList}
                                />
                            }
                        </div>
                        {this.state.editingHistory ?
                            <>
                                <h4 style={{ padding: 0 }}>History</h4>
                                <BillHistoryForm
                                    switchedToBill={this.state.switchedToBill}
                                    legislationNumber={this.state.legislationNumber}
                                    historyList={this.state.billHistory}
                                    organizedEvents={this.state.organizedEvents}
                                    handleEventChange={this.handleEventChange}
                                    billEvents={this.state.billEvents}
                                    billData={this.state.billData}
                                    toggleEditContent={this.toggleEditContent}
                                    saveEvents={this.saveEvents}
                                    hideAllEvents={this.state.hideAllEvents}
                                    togglehideAllEvents={this.togglehideAllEvents}
                                    changeToNewBillHistoryForm={this.changeToNewBillHistoryForm}
                                    actionTypes={this.state.actionTypes}
                                    memberList={this.state.memberList}
                                    committeeList={this.state.committeeList}
                                    versionsList={this.state.versionList.map(text => ({
                                        ...text,
                                        label: text.DocumentCode + " " + text.Description,
                                        value: text.LegislationTextID
                                    }))}
                                    reconsiderationEvents={this.state.reconsiderationEvents}
                                    getReconsiderationEvents={this.getReconsiderationEvents}
                                />
                            </>
                            : <div className='history-section'>
                                <div className='history-event-header'>
                                    <div className='header-and-sort'>
                                        <div style={{ display: "inline-flex", gridGap: "10px" }}>
                                            <h4 onClick={this.props.login.userClaims.roles.find(x => x === "Admin") ? () => this.toggleVersionList() : () => { }} style={{ padding: 0 }}>History</h4>
                                            {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR)
                                                ? <button type="button" className="button small-button remove-from-print" style={{ fontSize: '0.8em', maxHeight: "24px" }} onClick={this.toggleEditContent}>Edit</button>
                                                : <div />
                                            }
                                        </div>
                                        {this.state.billHistory.length > 0 &&
                                            <div className='sort-controls remove-from-print' onClick={() => this.toggleHistoryOrder()}>
                                                <span>Date</span>
                                                <div className='sort-icon-wrapper'>
                                                    <i className={'icon up-sort ' + (!this.state.defaultHistoryOrder ? "active" : "")} />
                                                    <i className={'icon down-sort ' + (this.state.defaultHistoryOrder ? "active" : "")} />
                                                </div>
                                            </div>}
                                    </div>
                                    {this.props.login.userClaims.resources.find(resource => resource === VERSION_AUTHOR)
                                        ? <Link to={`/bill-details/${sessionData.SessionCode}/${billData.LegislationNumber}/text/new-amendment`} className="button small-button remove-from-print" style={{ fontSize: "13px", maxHeight: "24px" }}>Create Amendment</Link>
                                        : <div />
                                    }
                                    {this.props.login.userClaims && this.props.login.userClaims.roles && this.props.login.userClaims.roles.find(x => x === "ImpactStatementAuthor")
                                        ? <button style={{ height: "24px", width: "170px", paddingTop: "4px" }} className='button primary impact-form-toggle' onClick={() => this.toggleDisplayStatementForm()}>Add Impact Statement</button>
                                        : <div />
                                    }
                                    <div />
                                    <div onClick={() => this.toggleEventReferenceCollapseAll()} className='toggle-button-wrapper remove-from-print'>
                                        <div />
                                        <span>{this.state.collapseAll ? "Expand All" : "Collapse All"}</span>
                                        <button className={this.state.collapseAll ? "arrow-down" : "arrow-up"}></button>
                                    </div>
                                </div>
                                <div className='history-events-wrapper'>
                                    {this.state.historyIsLoaded
                                        ? this.state.defaultHistoryOrder
                                            ? [...this.state.billHistory.filter(x => !x.DeletionDate).sort((a, b) => { return moment(a.EventDate).isAfter(b.EventDate, "day") ? -1 : moment(a.EventDate).isBefore(b.EventDate, "day") ? 1 : a.Sequence > b.Sequence ? -1 : 1 })].map((x, i) => {
                                                return <HistoryEvent
                                                    key={"event-" + i}
                                                    eventIndex={i}
                                                    event={x}
                                                    addCommitteeLink={this.addCommitteeLink}
                                                    collapsedEventReferences={this.state.collapsedEventReferences}
                                                    toggleEventReferenceCollapse={this.toggleEventReferenceCollapse}
                                                    toggleEventReferenceEdit={this.toggleEventReferenceEdit}
                                                    versionList={this.state.versionList}
                                                    eventReferenceValue={this.state.eventReferenceValue}
                                                    handleEventReferenceChange={this.handleEventReferenceChange}
                                                    saveEventReference={this.saveEventReference}
                                                    hasAccess={this.hasAccess}
                                                    toggleDeleteImpactStatementModal={this.toggleDeleteImpactStatementModal}
                                                    toggleEventReferenceCreate={this.toggleEventReferenceCreate}
                                                    createEventReference={this.createEventReference}
                                                    toggleDeleteEventReferenceModal={this.toggleDeleteEventReferenceModal}
                                                    toggleEventReferenceParent={this.toggleEventReferenceParent}
                                                    setEventReferenceParent={this.setEventReferenceParent}
                                                    committeeList={this.state.committeeList}
                                                />
                                            })
                                            : this.state.billHistory.filter(x => !x.DeletionDate).map((x, i) => {
                                                return <HistoryEvent
                                                    key={"event-" + i}
                                                    eventIndex={i}
                                                    event={x}
                                                    addCommitteeLink={this.addCommitteeLink}
                                                    collapsedEventReferences={this.state.collapsedEventReferences}
                                                    toggleEventReferenceCollapse={this.toggleEventReferenceCollapse}
                                                    toggleEventReferenceEdit={this.toggleEventReferenceEdit}
                                                    versionList={this.state.versionList}
                                                    eventReferenceValue={this.state.eventReferenceValue}
                                                    handleEventReferenceChange={this.handleEventReferenceChange}
                                                    saveEventReference={this.saveEventReference}
                                                    hasAccess={this.hasAccess}
                                                    toggleDeleteImpactStatementModal={this.toggleDeleteImpactStatementModal}
                                                    toggleEventReferenceCreate={this.toggleEventReferenceCreate}
                                                    createEventReference={this.createEventReference}
                                                    toggleDeleteEventReferenceModal={this.toggleDeleteEventReferenceModal}
                                                    toggleEventReferenceParent={this.toggleEventReferenceParent}
                                                    setEventReferenceParent={this.setEventReferenceParent}
                                                    committeeList={this.state.committeeList}
                                                />
                                            })
                                        : <div className="small-spinner" />
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const HistoryEvent = (props) => {
    let eventReferences = props.event.BillHistoryReferences ? props.event.BillHistoryReferences.filter(x => x.ActionReferenceType !== "Impact") : [];
    let impactStatements = props.event.BillHistoryReferences ? props.event.BillHistoryReferences.filter(x => x.ActionReferenceType === "Impact") : [];

    if (props.event.EventCode.includes("8500")) {
        impactStatements = [...impactStatements.filter(x => x.ReferenceText === props.event.Description)];
    }

    const getReplacementIndex = (referenceText) => {
        if (referenceText) {
            let amendmentIndex = referenceText.toLowerCase().indexOf("amendment");
            let substitueIndex = referenceText.toLowerCase().indexOf("substitute");
            return amendmentIndex > substitueIndex ? amendmentIndex : substitueIndex;
        } else {
            return null
        }
    }

    const getReplacementWord = (description) => {
        let replacementWord = "🐧"

        if (description.includes("House Subcommittee")) {
            replacementWord = "House Subcommittee";
        } else if (description.includes("Senate Subcommittee")) {
            replacementWord = "Senate Subcommittee";
        } else if (description.includes("House subcommittee")) {
            replacementWord = "House subcommittee";
        } else if (description.includes("Senate subcommittee")) {
            replacementWord = "Senate subcommittee";
        } else if (description.includes("Subcommittee")) {
            replacementWord = "Subcommittee";
        } else if (description.includes("subcommittee")) {
            replacementWord = "subcommittee";
        } else if (description.includes("House Committee")) {
            replacementWord = "House Committee";
        } else if (description.includes("Senate Committee")) {
            replacementWord = "Senate Committee";
        } else if (description.includes("House committee")) {
            replacementWord = "House committee";
        } else if (description.includes("Senate committee")) {
            replacementWord = "Senate committee";
        } else if (description.includes("Committee")) {
            replacementWord = "Committee";
        } else if (description.includes("committee")) {
            replacementWord = "committee";
        }

        return replacementWord
    }

    const buildDescription = (eventReferences) => {
        try {
            let replacementReference = eventReferences.find(x => x.ActionReferenceType === "HTML" && getReplacementIndex(x.ReferenceText) > -1 && x.ReferenceText[0] === props.event.ChamberCode)
            let replacementWord = getReplacementWord(props.event.Description);
            let committeeLink = replacementWord.toLowerCase().includes("subcommittee")
                ? linkSubcommitteeName(props.event)
                : linkCommitteeName(replacementReference.ReferenceText.slice(0, getReplacementIndex(replacementReference.ReferenceText)), props.event.ActorID)

            return replacementReference ? (props.event.CommitteeName ? props.addCommitteeLink(props.event) : props.event.Description ? props.event.Description.replace(/-/g, '\u2011') : "")
                .replace(replacementWord, committeeLink)
                : props.event.CommitteeName ? props.addCommitteeLink(props.event) : props.event.Description ? props.event.Description.replace(/-/g, '\u2011') : ""
        } catch (err) {
            return props.event.CommitteeName ? props.addCommitteeLink(props.event) : props.event.Description ? props.event.Description.replace(/-/g, '\u2011') : ""
        }
    }

    const linkCommitteeName = (committeeText, actorId) => {
        let linkedCommittee = committeeText;
        let committee;

        try {
            committee = props.committeeList.find(x =>
                committeeText.replace(/ /g, '').toLowerCase().includes(x.Name.replace(/ /g, '').toLowerCase())
                && x.ChamberCode === committeeText.slice(0, 1))

            if (committee) {
                linkedCommittee = linkedCommittee.replace(committeeText.slice(0, 2) + committee.Name, '<a href="/session-details/' + props.event.SessionCode + '/committee-information/' + committee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + committee.Name + '</a>')
                linkedCommittee = linkedCommittee.slice(0, linkedCommittee.indexOf("</a>") + 4);
                linkedCommittee += (committee.ParentCommitteeID ? " subcommittee" : " committee")
            } else if (!committee) {
                //Fallback to pulling committee by actorId if the BHRs don't have the correct language
                committee = props.committeeList.find(x => x.CommitteeID === actorId);
                if (linkedCommittee !== committee.Name) {
                    linkedCommittee = '<a href="/session-details/' + props.event.SessionCode + '/committee-information/' + committee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + committee.Name.slice(committee.Name.indexOf(":") + 1) + '</a>';
                    linkedCommittee += (committee.ParentCommitteeID ? " subcommittee" : " committee")
                }
            }

            return linkedCommittee;
        } catch (err) {
            console.log(err)
            return linkedCommittee;
        }
    }

    const linkSubcommitteeName = (event) => {
        try {
            let linkedSubcommittee = event.CommitteeName
            let committee = props.committeeList.find(x => x.Name === event.ParentCommitteeName && x.ChamberCode === event.ChamberCode)
            let subcommittee = props.committeeList.find(x => x.ParentCommitteeID === committee.CommitteeID && committee.Name.toLowerCase().includes(event.CommitteeName.toLowerCase()))

            if (subcommittee) {
                linkedSubcommittee = linkedSubcommittee.replace("Subcommittee", '<a href="/session-details/' + event.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + committee.ChamberCode + "-" + event.CommitteeName + '</a>')
            }

            return linkedSubcommittee
        } catch (err) {
            console.log(err)
            return linkedSubcommittee
        }
    }

    return (<div className={'history-event-row ' + (props.event.IsPublic ? '' : ' not-public')}>
        <div className="history-event-data">
            <span>{moment(props.event.EventDate).format("l")}</span>
            <span>{props.event.ActorType}</span>
        </div>
        <div className='history-event-info'>
            <div className='history-event-description'>
                <span dangerouslySetInnerHTML={{ __html: buildDescription(eventReferences) }} />
                {props.event.BillHistoryReferences && props.event.BillHistoryReferences.filter(x => x.ActionReferenceType !== "Committee").length > 0
                    ? <button onClick={() => props.toggleEventReferenceCollapse(props.eventIndex)} className={props.collapsedEventReferences[props.eventIndex] ? "arrow-down" : "arrow-up"}></button>
                    : <div />
                }
            </div>
            <div className={"history-link-wrapper " + (props.collapsedEventReferences[props.eventIndex] ? "collapsed" : "")}>
                {eventReferences.length > 0 && eventReferences.map((x, i) => {
                    /* They only want to see the PDF links for parent versions of amendments or amendment-like versions (conference reports, governor's recommendations) */
                    return (props.event.Description && PARENT_ELIGIBLE_EVENTS.some(y => props.event.Description.toLowerCase().includes(y)) && x.ActionReferenceType === "HTML" && !x.ParentLegislationTextID && !PARENT_ELIGIBLE_EVENTS.some(y => x.ReferenceText.toLowerCase().includes(y)))
                        || (eventReferences.filter(y => y.ReferenceID !== x.ReferenceID).find(y => PARENT_ELIGIBLE_EVENTS.some(z => y.ReferenceText.toLowerCase().includes(z)) && x.ActionReferenceType === "HTML" && !x.ParentLegislationTextID))
                        ? null
                        : <EventReference
                            key={"reference-" + props.eventIndex + "-" + i}
                            event={props.event}
                            eventIndex={props.eventIndex}
                            eventReference={x}
                            eventReferenceIndex={i}
                            eventReferences={eventReferences}
                            collapsedEventReferences={props.collapsedEventReferences}
                            toggleEventReferenceEdit={props.toggleEventReferenceEdit}
                            versionList={props.versionList}
                            eventReferenceValue={props.eventReferenceValue}
                            handleEventReferenceChange={props.handleEventReferenceChange}
                            saveEventReference={props.saveEventReference}
                            hasAccess={props.hasAccess}
                            toggleDeleteEventReferenceModal={props.toggleDeleteEventReferenceModal}
                            toggleEventReferenceParent={props.toggleEventReferenceParent}
                            setEventReferenceParent={props.setEventReferenceParent}
                        />
                })}
                {(
                    (TEXT_EVENTS.find(x => x === props.event.EventCode) && !eventReferences.find(x => x.ActionReferenceType === "PDF") && !eventReferences.find(x => x.ActionReferenceType === "HTML"))
                    || (CONFERENCE_EVENTS.find(x => x === props.EventCode))
                    || (GOV_EVENTS.find(x => x === props.EventCode))
                    || (eventReferences.find(x => x.ActionReferenceType.includes("Vote")) && !eventReferences.find(x => x.ActionReferenceType === "PDF") && !eventReferences.find(x => x.ActionReferenceType === "HTML"))) &&
                    <div style={{ display: "inline-flex" }}>
                        {props.hasAccess() && props.event.creating
                            ? <div style={{ display: "grid", gridTemplateColumns: "300px 20px 20px" }}>
                                <Select
                                    options={props.versionList}
                                    value={props.eventReferenceValue}
                                    onChange={value => props.handleEventReferenceChange(value)}
                                    getOptionLabel={x => x.Description + " - " + x.DocumentCode + " - " + x.LDNumber}
                                    getOptionValue={x => x}
                                    classNamePrefix='no-width-dropdown-input'
                                    styles={selectStyle}
                                />
                                <a className="icon save" onClick={() => props.createEventReference(props.event.LegislationEventID, props.eventReferenceValue)}></a>
                                <a className="icon delete" onClick={() => props.toggleEventReferenceCreate(props.event.LegislationEventID)}></a>
                            </div>
                            : !eventReferences.find(x => x.ActionReferenceType === "PDF") && !eventReferences.find(x => x.ActionReferenceType === "HTML") &&
                            <>
                                <label>Legislation Text Pending</label>
                                {props.hasAccess() &&
                                    <a className="icon edit" style={{ margin: "2px 5px 0px" }} onClick={() => props.toggleEventReferenceCreate(props.event.LegislationEventID)}></a>}
                            </>
                        }
                    </div>
                }
            </div>
            {impactStatements.length > 0 &&
                <div className={"impact-statement-wrapper " + (props.collapsedEventReferences[props.eventIndex] ? "collapsed" : "")}>
                    {impactStatements.map((x, i) => {
                        return <EventReference
                            key={"statement-" + props.eventIndex + "-" + i}
                            event={props.event}
                            eventIndex={props.eventIndex}
                            eventReference={x}
                            collapsedEventReferences={props.collapsedEventReferences}
                            hasAccess={props.hasAccess}
                            toggleDeleteImpactStatementModal={props.toggleDeleteImpactStatementModal}
                        />
                    })}
                </div>
            }
        </div>
    </div>
    )
}

const EventReference = (props) => {
    let linkText;

    if (props.eventReference.ActionReferenceType === "PDF") {
        if ((PARENT_ELIGIBLE_EVENTS.some(x => props.event.Description.toLowerCase().includes(x)))
            || (props.eventReferences.filter(y => y.ReferenceID !== props.eventReference.ReferenceID).find(y => PARENT_ELIGIBLE_EVENTS.some(z => y.ReferenceText.toLowerCase().includes(z)) && !props.eventReference.ParentLegislationTextID))) {
            linkText = props.eventReference.ReferenceText
        } else {
            linkText = "PDF";
        }
    } else if (props.eventReference.ReferenceText && props.eventReference.ReferenceText.includes("Vote")) {
        linkText = "Vote";
    } else {
        linkText = props.eventReference.ReferenceText;
    }

    return (
        <>
            {props.eventReference.ActionReferenceType !== "Committee" &&
                <div style={props.eventReference.editing ? { width: "50%" } : {}}>
                    {props.eventReference.editing
                        ? <div style={{ display: "grid", gridTemplateColumns: "1fr 20px 20px" }}>
                            <Select
                                options={props.versionList}
                                value={props.eventReferenceValue}
                                onChange={value => props.handleEventReferenceChange(value)}
                                getOptionLabel={x => x.Description + " - " + x.DocumentCode + " - " + x.LDNumber}
                                getOptionValue={x => x}
                                classNamePrefix='no-width-dropdown-input'
                                styles={selectStyle}
                            />
                            <a className="icon save" onClick={() => props.saveEventReference(props.event.LegislationEventID, props.eventReferenceIndex, props.eventReferenceValue)}></a>
                            <a className="icon delete" onClick={() => props.toggleEventReferenceEdit(props.event.LegislationEventID, props.eventReference.ReferenceID)}></a>
                        </div>
                        : <div style={{ display: "inline-flex" }}>
                            {props.eventReference.ActionReferenceType === "HTML"
                                ? <Link to={props.eventReference.BillHistoryLink.split(".gov")[1]}>{linkText}</Link>
                                : props.eventReference.BillHistoryLink !== "" ? <a href={props.eventReference.BillHistoryLink}>{linkText}</a> : props.eventReference.ReferenceText
                            }
                            {props.hasAccess() &&
                                <>
                                    {props.eventReference.ActionReferenceType === "HTML" &&
                                        <a className="icon edit" style={{ margin: "2px 5px 0px" }} onClick={() => props.toggleEventReferenceEdit(props.event.LegislationEventID, props.eventReference.ReferenceID)} />
                                    }
                                    {/* {props.eventReference.ActionReferenceType === "Impact" &&
                                <a className="icon delete" style={{ margin: "2px 5px 0px" }} onClick={() => props.toggleDeleteImpactStatementModal(props.eventReference)} /> */
                                    }
                                    {!["Vote", "Impact"].includes(props.eventReference.ActionReferenceType) &&
                                        <a className="icon delete" style={{ margin: "2px 5px 0px" }} onClick={() => props.toggleDeleteEventReferenceModal(props.event.LegislationEventID, props.eventReferenceIndex)} />
                                    }
                                    {props.eventReference.ParentLegislationTextID == 0 && props.eventReference.ReferenceText && PARENT_ELIGIBLE_EVENTS.some(x => props.eventReference.ReferenceText.toLowerCase().includes(x)) && props.event.parenting
                                        ? <div style={{ display: "grid", gridTemplateColumns: "300px 20px 20px" }}>
                                            <Select
                                                options={props.versionList}
                                                value={props.eventReferenceValue}
                                                onChange={value => props.handleEventReferenceChange(value)}
                                                getOptionLabel={x => x.Description + " - " + x.DocumentCode + " - " + x.LDNumber}
                                                getOptionValue={x => x}
                                                classNamePrefix='no-width-dropdown-input'
                                                styles={selectStyle}
                                            />
                                            <a className="icon save" onClick={() => props.setEventReferenceParent(props.event.LegislationEventID, props.eventReferenceValue)}></a>
                                            <a className="icon delete" onClick={() => props.toggleEventReferenceParent(props.event.LegislationEventID)}></a>
                                        </div>
                                        : <>{props.eventReference.ParentLegislationTextID == 0 && props.eventReference.ReferenceText && PARENT_ELIGIBLE_EVENTS.some(x => props.eventReference.ReferenceText.toLowerCase().includes(x)) && <><label>Add Parent Version</label> <a className="icon edit" style={{ margin: "2px 5px 0px" }} onClick={() => props.toggleEventReferenceParent(props.event.LegislationEventID)} /></>}</>
                                    }
                                </>
                            }
                        </div>}
                </div>
            }
        </>
    )
}

const NewPublicBillDetails = connect(
    (state) => {
        const { bills, session, patrons, votes, login, nav, minutes, members, committee, organizations, collection } = state;
        return {
            bills,
            session,
            patrons,
            votes,
            login,
            nav,
            minutes,
            members,
            committee,
            organizations,
            collection
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, voteActionCreators, billActionCreators, sessionActionCreators, patronActionCreators, authActionCreators, navActionCreators, minutesActionCreators, memberActionCreators, committeeActionCreators, orgActionCreators, collectionActionCreators), dispatch)
        }
    }
)(NewBillDetailsComponent)

export default NewPublicBillDetails;
